<template>
    <div class="field mb-2">
        <label class="question-label">{{ questionTitle }}</label>
        <div class="control ml-2">
            <component :is="questionComponent" :question="question" />
        </div>
    </div>
</template>

<script>
import TextQuestion from "./question-types/TextQuestion.vue";
import DateQuestion from "./question-types/DateQuestion.vue";
import DropdownQuestion from "./question-types/DropdownQuestion.vue";
import LongtextQuestion from "./question-types/LongtextQuestion.vue";
import RadioQuestion from "./question-types/RadioQuestion.vue";
import CheckQuestion from "./question-types/CheckQuestion.vue";
import FileQuestion from "./question-types/FileQuestion.vue";
import TableQuestion from "./question-types/TableQuestion.vue";
import SimpleSelectQuestion from "./question-types/SimpleSelectQuestion.vue";
import PhotoQuestion from "./question-types/PhotoQuestion.vue";
import RateQuestion from "./question-types/RateQuestion.vue";
import NumberQuestion from "./question-types/NumberQuestion.vue";

export default {
    name: "question",
    props: {
        question: {
            type: Object,
            required: true,
        },
    },
    computed: {
        questionTitle() {
            let title = this.question.title;
            let order = this.question.order;
            return `${order} ${title}`;
        },
        questionComponent() {
            switch (this.question.discriminator) {
                case "text":
                    return TextQuestion;
                case "date":
                    return DateQuestion;
                case "dropdown":
                    return DropdownQuestion;
                case "longtext":
                    return LongtextQuestion;
                case "radio":
                    return RadioQuestion;
                case "check":
                    return CheckQuestion;
                case "file":
                    return FileQuestion;
                case "table":
                    return TableQuestion;
                case "simpleselect":
                    return SimpleSelectQuestion;
                case "photo":
                    return PhotoQuestion;
                case "rate":
                    return RateQuestion;
                case "number":
                    return NumberQuestion;
            }
            return null;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/_variables";

.question-label {
    color: #363636;
    display: block;
    font-size: 1rem;
    font-weight: 700;
    color: $primary;
}
</style>